import React, { useEffect, useState } from 'react';
import { TextField, Button } from '@mui/material';
import { useUserApis } from '../../apis/UsersAPIs';

function EditProfile({ onClose, userId }) {
    const { fetchUsername, updateProfile } = useUserApis();
    const [username, setUsername] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        // Fetch the user data based on the user ID
        if (userId) {
            fetchUsername(userId).then(fetchedUsername => {
                if (fetchedUsername) {
                    setUsername(fetchedUsername);
                } else {
                    setError('User not found');
                }
            }).catch(() => {
                setError('Error fetching user data');
            });
        }
    }, [userId]);

    const handleSave = async () => {
        // Validate input
        if (!username || !oldPassword || !newPassword || !confirmPassword) {
            setError('All fields are required.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('New passwords do not match.');
            return;
        }

        // Prepare user data for update
        const userData = {
            username,
            oldPassword,
            newPassword
        };

        // Call updateProfile API function
        const success = await updateProfile(userData, userId);
        if (success) {
            onClose(); // Close modal on success
        } else {
            setError('Failed to update profile.');
        }
    };

    return (
        <div>
            <TextField
                label="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
                margin="normal"
            />
            <TextField
                label="Old Password"
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                fullWidth
                margin="normal"
            />
            <TextField
                label="New Password"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                fullWidth
                margin="normal"
            />
            <TextField
                label="Confirm New Password"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                fullWidth
                margin="normal"
            />
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <Button variant="contained" color="primary" onClick={handleSave}>
                Save Changes
            </Button>
        </div>
    );
}

export default EditProfile;
